import React from 'react';
import PropTypes from 'prop-types';

const ErrorMessage = ({ errorLabel }) => {
	return (
		<div className="alert alert-warning d-flex">
			<i className="ddc-icon ddc-icon-alert mr-3" aria-hidden="true" />
			<span>{errorLabel}</span>
		</div>
	);
};

ErrorMessage.propTypes = {
	errorLabel: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.arrayOf(PropTypes.element)
	]).isRequired
};

export default ErrorMessage;
